import { useEffect } from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { FieldItem } from '../FieldItem.js';
import { DurationInput } from './DurationInput.js';
import { jsx } from '@emotion/react';

var DURATION_INVALID_TEXT = '종료일은 시작일보다 빠르게 설정할 수 없습니다.';
function DurationInputField(_ref) {
  var _formState$errors;
  var _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'duration' : _ref$name,
    onValue = _ref.onValue;
  var _useFormContext = useFormContext(),
    control = _useFormContext.control,
    formState = _useFormContext.formState,
    trigger = _useFormContext.trigger,
    getValues = _useFormContext.getValues;
  var errorInfo = (_formState$errors = formState.errors) === null || _formState$errors === void 0 ? void 0 : _formState$errors[name];
  useEffect(function () {
    var value = getValues(name);
    if (value) {
      trigger();
    }
  }, []);
  return jsx(FieldItem, {
    error: true,
    hint: errorInfo === null || errorInfo === void 0 ? void 0 : errorInfo.message,
    hintAlign: "end"
  }, jsx(Controller, {
    control: control,
    name: name,
    rules: {
      validate: function validate(value) {
        var startAt = value.startAt,
          endAt = value.endAt;
        return startAt && endAt && startAt > endAt ? DURATION_INVALID_TEXT : true;
      }
    },
    render: function render(_ref2) {
      var field = _ref2.field;
      return jsx(DurationInput, {
        value: field.value,
        onChange: function onChange(value) {
          field.onChange(value);
          onValue === null || onValue === void 0 || onValue(value);
          trigger(name);
        }
      });
    }
  }));
}

export { DURATION_INVALID_TEXT, DurationInputField };
//# sourceMappingURL=DurationInputField.js.map
